import React, { useState, useEffect } from "react";

import Icon from "@cayuse/shared-react.components.icon";
import IconButton from "@cayuse/shared-react.components.icon-button";

import { CAYUSE_TYPES } from "globals/constants";

import { QuestionFooter, QuestionHeader } from "./Question";
import { ReserchTeamCustomSettings } from "./ReserchTeamCustomSettings";
import styles from "./ResearchTeamComponent.css";

const defaultExtraSettings = {
    costShareEffort: false,
    costShareEffortRequired: false,
    creditField: false,
    creditFieldRequired: false,
    defaultEffortFormat: 'Percentage',
    externalResearchers: false,
    sponsoredEffort: false,
    sponsoredEffortRequired: false,
};

function ResearchTeamComponent({
    completeFormModel,
    config,
    onChange,
    onDelete,
}) {
    const [localConfig, setLocalConfig] = useState(config);

    useEffect(() => {
        config.extraSettings = {
            ...defaultExtraSettings,
            ...config.extraSettings,
        };

		setLocalConfig(config);
    }, []);

    const onChangeConfig = (newProps) => {
        const newConfig = { ...localConfig, ...newProps };
        onChange(newConfig);
        setLocalConfig(newConfig);
    };

    return (
        <>
            <QuestionHeader
                config={config}
                onChangeConfig={onChangeConfig}
            ></QuestionHeader>
            <div className={`ui form ${styles.container}`}>
                <div className={styles.iconButton}>
                    <IconButton icon="plus" disabled={true} primary>
                        Add Team Member
                    </IconButton>
                </div>
                <div className={styles.text}>
                    <strong>0% of total credit has been allocated</strong>
                    <br />
                </div>
            </div>
            <div className={`ui form ${styles.container}`}>
                <div className={`ui input ${styles.input}`}>
                    <label>Name:</label>
                    <input
                        disabled={true}
                        placeholder={"Click to search..."}
                    ></input>
                </div>
                <div className={`ui input ${styles.input}`}>
                    <label>Role:</label>
                    <select disabled className={styles.disabled}>
                        <option>Select...</option>
                    </select>
                </div>
                <div className={`ui input ${styles.icon}`}>
                    <Icon size="bigger" name="trash" />
                </div>
            </div>
            <div className={`ui form ${styles.container2}`}>
                <div className={styles.associationsContainer}>
                    <div>
                        <label>Internal Association*</label>
                    </div>
                    <div className={styles.colHeader}>
                        <label>Credit*</label>
                    </div>
                    <div className={styles.colHeader}>
                        <label>Cost Share Effort*</label>
                    </div>
                    <div className={styles.colHeader}>
                        <label>Sponsored Effort*</label>
                    </div>
                    <div className={styles.colHeader}>
                        <label>Total Effort</label>
                    </div>
                    <div></div>

                    <div></div>
                    <div></div>
                    <div className={styles.casColumnHeader}>
                        <div className={styles.centerAligned}>
                            <label>C</label>
                        </div>
                        <div className={styles.centerAligned}>
                            <label>A</label>
                        </div>
                        <div className={styles.centerAligned}>
                            <label>S</label>
                        </div>
                    </div>
                    <div className={styles.casColumnHeader}>
                        <div className={styles.centerAligned}>
                            <label>C</label>
                        </div>
                        <div className={styles.centerAligned}>
                            <label>A</label>
                        </div>
                        <div className={styles.centerAligned}>
                            <label>S</label>
                        </div>
                    </div>
                    <div></div>
                    <div></div>

                    <div>
                        <select disabled className={styles.disabled}>
                            <option>Select...</option>
                        </select>
                    </div>
                    <div className={`ui input`}>
                        <input disabled />
                    </div>
                    <div className={styles.casColumn}>
                        <div className={`ui input`}>
                            <input disabled />
                        </div>
                        <div className={`ui input`}>
                            <input disabled />
                        </div>
                        <div className={`ui input`}>
                            <input disabled />
                        </div>
                    </div>
                    <div className={styles.casColumn}>
                        <div className={`ui input`}>
                            <input disabled />
                        </div>
                        <div className={`ui input`}>
                            <input disabled />
                        </div>
                        <div className={`ui input`}>
                            <input disabled />
                        </div>
                    </div>
                    <div className={styles.centerAligned}>
                        <label>- -</label>
                    </div>
                    <div className={styles.centerAligned}>
                        <Icon size="bigger" name="trash" disabled />
                    </div>
                </div>
            </div>
            <div className={styles.container3}>
                <IconButton icon="plus" disabled={true} primary>
                    Add Internal Association
                </IconButton>
            </div>
            <QuestionFooter
                completeFormModel={completeFormModel}
                config={config}
                onChangeConfig={onChangeConfig}
                onDelete={onDelete}
                CustomSettingsComponent={ReserchTeamCustomSettings}
            ></QuestionFooter>
        </>
    );
}

ResearchTeamComponent.showInPalette = () => true;

ResearchTeamComponent.paletteInformation = () => ({
    id: "researchTeam",
    name: "Research Team",
    type: "researchTeam",
    group: "sponsoredProject",
});

ResearchTeamComponent.newElement = () => ({
    designInfo: {
        stencilSuperIds: ["Component"],
        stencilId: "cayuse-research-team",
        customStencilId: "null",
    },
    type: "researchTeam",
    cayuseType: CAYUSE_TYPES.RESEARCH_TEAM,
    cayuseShortLabel: "Research Team",
});

ResearchTeamComponent.initialValue = "{{researchTeam}}";

export default ResearchTeamComponent;
